import { render } from "./CompaniesComponent.vue?vue&type=template&id=2149a587"
import script from "./CompaniesComponent.vue?vue&type=script&lang=js"
export * from "./CompaniesComponent.vue?vue&type=script&lang=js"

import "./CompaniesComponent.vue?vue&type=style&index=0&id=2149a587&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__